import { Component } from "react"
import PropTypes from "prop-types"
import Dot from "./dot"
import "./style.scss"

class Dots extends Component {
  static propTypes = {
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
    findDots: PropTypes.func.isRequired,
    focus: PropTypes.func.isRequired,
    blur: PropTypes.func.isRequired,
    focused: PropTypes.string,
    onDotClick: PropTypes.func,
  }

  constructor(...args) {
    super(...args)

    this.state = { showToolTip: false }
  }

  mouseMove = ({ showToolTip, nativeEvent }) => {
    this.setState({ showToolTip, nativeEvent })
  }

  componentDidMount() {
    this.props.subscribe(this.mouseMove)
  }

  componentWillUnmount() {
    this.props.unsubscribe(this.mouseMove)
  }

  render() {
    const { findDots, focus, blur, focused, onDotClick } = this.props
    const { showToolTip, nativeEvent } = this.state

    if (showToolTip) {
      const coords = findDots(nativeEvent.offsetX)
      if (coords) {
        const dots = coords
        return dots.map(dot =>
          <g className="dots" key={dot.id} transform={`translate(${dot.x},0)`}>
            <Dot
              color={dot.color}
              y={dot.y}
              id={dot.id}
              focused={focused}
              focus={focus}
              blur={blur}
              onClick={onDotClick}
            />
          </g>,
        )
      }
    }
    return null
  }
}

export default Dots
